import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import { defineComponent, inject } from "vue";
import titleUrl from "@/assets/img/pc/homePage/ss-title.png";
import { homePageContextKey } from "@/context/home-page";
// components
import SelectBtn from "@/components/pc/common/select-btns.vue";
import Integration from "./integration.vue";
import Eliminated from "./eliminated.vue";
import Championship from "./championship.vue";
import { raceQuarterOptPC, groupTypeOptPC, raceTypeOptPC
// raceRoundPC,
} from "@/config/homePage";
export default defineComponent({
  name: "MatchProcessPc",
  setup() {
    const {
      homePageState,
      raceQuarterSwitchFct,
      groupSwitchFct,
      raceTypeSwitchFct
    } = inject(homePageContextKey);
    return () => {
      return _createVNode("div", {
        "class": "match pc-information"
      }, [_createVNode("div", {
        "class": "title-box",
        "id": "ss-process"
      }, [_createVNode("img", {
        "class": "title",
        "src": titleUrl
      }, null)]), _createVNode("div", {
        "class": "select-btn"
      }, [_createVNode(SelectBtn, {
        "onClick": raceQuarterSwitchFct,
        "options": raceQuarterOptPC,
        "dataValue": homePageState.raceQuartertype,
        "defaultOption": raceQuarterOptPC[homePageState.raceQuartertype - 1]
      }, null), _createVNode(SelectBtn, {
        "class": "btn-center",
        "onClick": groupSwitchFct,
        "dataValue": homePageState.groupType,
        "options": groupTypeOptPC
      }, null), _createVNode(SelectBtn, {
        "onClick": raceTypeSwitchFct,
        "options": raceTypeOptPC,
        "dataValue": homePageState.raceType,
        "defaultOption": raceTypeOptPC[homePageState.raceType - 1]
      }, null)]), homePageState.isNone ? _createVNode("div", {
        "class": "none-tips"
      }, [_createTextVNode("\u6682\u65E0\u6570\u636E\uFF0C\u656C\u8BF7\u671F\u5F85")]) : _createVNode("div", null, [homePageState.raceType === 1 && _createVNode(Integration, null, null), homePageState.raceType === 2 && _createVNode(Eliminated, null, null), homePageState.raceType === 3 && _createVNode(Championship, null, null)])]);
    };
  }
});